import { BaseDropdownInterface } from '@interfaces/base-dropdown.interface';

/**
 * Converts a list of strings to dropdown options. The string is the id and the name.
 */
export function toDropdownOptions(values: string[] | null | undefined): BaseDropdownInterface[] {
  return (values ?? []).map((value: string) => ({ id: value, name: value }));
}
